/** Pieczątki miejsc — zsynchronizowane z PaszportDolnegoSlaska-mobile/src/data/placeStamps.ts */
import stamp1 from '../assets/pieczatki/1-park-bukowiec.png'
import stamp2 from '../assets/pieczatki/2-opactwo-lubiaz.png'
import stamp3 from '../assets/pieczatki/3-palac-marianny.png'
import stamp4 from '../assets/pieczatki/4-muzeum.png'
import stamp5 from '../assets/pieczatki/5-wojslawice.png'
import stamp6 from '../assets/pieczatki/6-wodospad-wilczki.png'
import stamp7 from '../assets/pieczatki/7-dzikowiec.png'
import stamp8 from '../assets/pieczatki/8-sciezka.png'
import stamp9 from '../assets/pieczatki/9-zalew-mietkow.png'
import stamp10 from '../assets/pieczatki/10-szwajcaria-lwowecka.png'
import stamp11 from '../assets/pieczatki/11-bardo.png'
import stamp12 from '../assets/pieczatki/12-radunia.png'

export const placeStampById: Record<number, string> = {
  1: stamp1,
  2: stamp2,
  3: stamp3,
  4: stamp4,
  5: stamp5,
  6: stamp6,
  7: stamp7,
  8: stamp8,
  9: stamp9,
  10: stamp10,
  11: stamp11,
  12: stamp12,
}

export function hasPlaceStamp(placeId: number): boolean {
  return Object.prototype.hasOwnProperty.call(placeStampById, placeId)
}

/** Kolejność dekoracyjna (logowanie, hero). */
export const decorStampPlaceIds = [1, 2, 3, 9, 6, 5] as const

export const decorStampSources: string[] = decorStampPlaceIds.map((id) => placeStampById[id]!)
